import React, { Component } from "react";
import { bindActionCreators } from "redux";
import withRedux from "next-redux-wrapper";
import withReduxSaga from "next-redux-saga";
import Head from "next/head";
import PropTypes from "prop-types";
import Store from "store";
import { fetchSearchResult } from "store/posts/actions";
import NProgress from "components/NProgress";
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import { Router } from "routes";
import ResultItems from "/components/resultItems";
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ResultNotFound from '/components/resultNotFound';
import TagManager from 'react-gtm-module'
import SearchIcon from '@material-ui/icons/Search';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import VideoCardPoster from "/components/Video/VideoCardPoster";
import VideoCardParts from '/components/Video/VideoCardParts';
import Loading from "/components/Search/Loading";
import SearchItems from "/components/Search/SearchItems";
import Pagination from "/components/Search/Pagination";
import SeoMeta from "/components/seoMeta";

const tagManagerArgs = {
    // gtmId: 'GTM-WCJSTPT',
    dataLayer: {
      event: 'searchResultEvent',
      eventCategory: 'site search',
      eventAction: 'zero results',
      eventLabel: 'search query',      
    }
}

const styles = theme => ({
    layout: {
        marginLeft: 'auto',
        marginRight: 'auto',
        marginBottom: 100,
        [theme.breakpoints.up('sm')]: {
            width: 900,
        },
        [theme.breakpoints.only('sm')]: {
            width: 650,
            padding: '0px 20px'
        },
        [theme.breakpoints.only('xs')]: {
            padding: '0px 20px'
        },
    },
    textField: {
      padding: '20px 0px',
      margin: '25px 0px 0px',
      width: '100%',
      // "& input":{
      //   fontFamily: "'Zawgyi-One','serif'",
      // }
    },
    customDivider: {
      backgroundColor: 'rgba(0, 0, 0, 0.35)',
     
    },
    resultLeft: {
        padding: '2px 0px 0px',
        fontWeight: 'bold', 
      },
    sortBy: {
        opacity: 0.7,
        padding: '4px 14px',
    },
    button: {
      margin: '13px 0px 23px',
      padding: '1px 15px 0px 30px',
      letterSpacing: '1px'
  },
  itemContainer: {
      padding: '20px 0px 20px'
  }
});

function Tab(props) {
  return <div >
    <Typography 
      className={ props.isActive ? 'navigationActive' : '' }
      onClick={ props.onActiveTab }
      style={{ textAlign: 'right',
      padding: '4px 14px',
      cursor: 'pointer'}} 
      variant="caption">{ props.content }</Typography>
  </div>
};

function CustomRadio(props) {
  return (
   <Radio
    checked={ props.isActiveRadio }
    onChange={props.onActiveRadio}
    value={props.content}
    color="primary"
  />)
};
class SearchResult extends Component {
  constructor(props){
    super(props);
    this.state = {
      q: this.props.url.query.q ? this.props.url.query.q: null,
      selectedTabName:  this.props.url.query.sort ? this.props.url.query.sort: 'date',
      total: [
          { id: 1, name: 'relevance' },
          { id: 2, name: 'date' }
      ],
      types: [
        { id: 3, name: 'all'},
        { id: 1, name: 'articles'},
        { id: 2, name: 'videos'},
      ],
      type: this.props.url.query.sc ? this.props.url.query.sc : 'all',
      loading: false
    };
    this.searchResultItems = this.searchResultItems.bind(this)
    // this.searchDateItems = this.searchDateItems.bind(this)
    // this.searchRelevanceItems = this.searchRelevanceItems.bind(this)
  }
 
  static getInitialProps({ store, query, asPath, isServer }) {
    const { q, page } = query;
    let sc = query.sc && query.sc != undefined ? query.sc : 'all'
    let sort = query.sort ? query.sort : 'date'
    store.dispatch(fetchSearchResult({ q, page, sc, sort })); 
    return { q, page, sc, sort, asPath, isServer };
  } 
  searchResultItems () {
    const { searchResult, meta } = this.props;
    return (
      <SearchItems 
      loading={this.state.loading} 
      type={this.props.url.query.sc}
      dateOrRelevanceItems={searchResult} 
      lastPage={meta && meta.last_page ? meta.last_page : null} 
      page={this.props.page}
      query={this.props.url.query} />
    )
  }  
  // searchDateItems () {
  //   const { searchDate, meta } = this.props;
  //   return (
  //     <SearchItems 
  //     loading={this.state.loading} 
  //     type={this.props.url.query.sc} 
  //     dateOrRelevanceItems={searchDate} 
  //     lastPage={meta.last_page} 
  //     page={this.props.page}
  //     query={this.props.url.query} />
  //   )
  // }
  // searchRelevanceItems () {
  //   const { searchRelevance, searchRelevanceMeta } = this.props;
  //   return (
  //     <SearchItems 
  //     loading={this.state.loading} 
  //     type={this.props.url.query.sc} 
  //     dateOrRelevanceItems={searchRelevance} 
  //     lastPage={searchRelevanceMeta.last_page} 
  //     page={this.props.page}
  //     query={this.props.url.query} />
  //   )
  // }

  setActiveTab = (sort) => {
    this.setState({ selectedTabName : sort })
     Router.pushRoute(`/search-results?q=${this.props.url.query.q}&sc=${this.props.url.query.sc}&page=1&sort=${sort}`)
  } 

  isActive(name) {
    return this.state.selectedTabName === name
  }

  setActiveRadio = (typeName) => {
     this.setState({ 
      loading: true
    })
    if(this.props.url.query.q)
      Router.pushRoute(`/search-results?q=${this.props.url.query.q}&sc=${typeName}&page=1&sort=${this.props.url.query.sort}`)
  } 

  isActiveRadio(name) {
    return this.state.type === name // for search index checked
  }

  handleSubmit(that){
    that.preventDefault();
    if(this.state.q && this.state.type)
    Router.pushRoute(`/search-results?q=${this.state.q}&sc=${this.state.type}&page=1&sort=${this.props.sort}`)
  }
  
  render() {
    const { classes, searchResult, meta } = this.props;
    let myObj = this.props.url.query;
    function isEmpty(myObj){
      return (Object.getOwnPropertyNames(myObj).length === 0); //returns an array of all properties 
    }
    let titleName = `Search result for ${this.props.url.query.q}`
    return (
      <div>
        <Head>
          <title>{titleName}</title>
        </Head>
        <SeoMeta 
            url={`${process.env.BACKEND_URL}${this.props.url.asPath}`} 
            type="article"
            title={titleName}
            description={titleName}
            image='https://duwun-data.sgp1.cdn.digitaloceanspaces.com/react-assets/image/duwun-news-logo.jpg'
            section="search-results"
            keywords={`Result, Search, ${this.props.url.query.q}`}
          />        
        <NProgress />
        <div className={classes.layout}>
        <Grid container>
          <Grid item xs={12} style={{marginBottom: 10}}>
            <form onSubmit={this.handleSubmit.bind(this)}>
              <TextField
                onChange={(event) => this.setState({q: event.target.value})}
                id="standard-search"
                placeholder="Type your keywords"
                type="search"
                value={this.state.q || ''}
                className={classes.textField}
                margin="normal"
                InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                            <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              <div style={{ marginBottom: 20 }}>
                {
                  this.state.types.map((item, i) => {
                    return(
                      <FormControlLabel key={item.id} control={
                        <CustomRadio content={ item.name } 
                        isActiveRadio={ this.isActiveRadio(item.name) } 
                        onActiveRadio={ 
                          this.setActiveRadio.bind(this, item.name)
                        } />
                      } label={item.name} />
                    )
                  })
                }
              </div>
              </form>
              { !isEmpty(myObj) ? searchResult && searchResult.length == 0 ? <ResultNotFound /> 
                 : <div>
                    <Grid item xs={12} sm container style={{textTransform: 'uppercase'}}>
                      <Grid item xs container direction="column" spacing={16}>
                        <Grid item xs>
                          <Typography gutterBottom variant="caption" className={classes.resultLeft}>
                              Result
                          </Typography>
                        </Grid>
                        </Grid>
                        <Grid item>
                            <Typography className={classes.sortBy} variant="caption">Sort By</Typography>
                        </Grid>
                          {this.state.total.map(function (el, i) {
                          return  <div key={ i }><Grid item><Tab 
                              content={ el.name } 
                              isActive={ this.isActive(el.name) } 
                              onActiveTab={ 
                                this.setActiveTab.bind(this, el.name)
                              }
                          /></Grid>
                          </div>
                          }, this)
                          }   
                    </Grid>
                    <Divider className={classes.customDivider}/>
                    {this.state.loading ? 
                      <Loading />
                      :
                      this.props.sc == 'all' ?
                      <React.Fragment>
                        {searchResult && searchResult.length > 0 && searchResult.map((item, index) => {
                          let poster = item.media_id ? this.props.width === 'xs' ? item.posters.video_section_teaser : item.posters.thumb : null
                          const videoTypeIndex = item.categories && item.categories.findIndex((category) => category.type === 'VIDEO')
                          const tvTypeIndex = item.categories && item.categories.findIndex((category) => category.type === 'TV')
                  
                          const videoCategoriesType = item.categories && item.categories.length !== 0 && videoTypeIndex != -1 ? item.categories[videoTypeIndex].type  : null;
                          const tvCategoriesType = item.categories && item.categories.length !== 0 && tvTypeIndex != -1 ? item.categories[tvTypeIndex].type  : null;
                          return (
                            <React.Fragment key={index}>
                              {
                                item.media_id ?
                                <React.Fragment>
                                  <Grid container
                                    direction="row"
                                    justify="center"
                                    alignItems="center" className={classes.itemContainer} spacing={16}>
                                      <Grid xs={12} md={12} lg={6} item>  
                                        <VideoCardPoster 
                                          routeName={item.type == 'VIDEO' || videoCategoriesType === 'VIDEO' ? 'videoDetail' : 
                                                      tvCategoriesType === 'TV' ? 'tvDetail' : 'videoDetail' } // if type is not VIDEO or TV, go to videoDetail.  
                                          item={item} 
                                          videoPoster={poster} 
                                          videoImgHeight={ this.props.width === 'xs' ? 100 : 90 } 
                                        />
                                      </Grid>
                                      <Grid item xs={12} md={12} lg={6} className={classes.textContainer}>
                                        <VideoCardParts 
                                          routeName={item.type == 'VIDEO' || videoCategoriesType === 'VIDEO' ? 'videoDetail' : 
                                                      tvCategoriesType === 'TV' ? 'tvDetail' : 'videoDetail' } // if type is not VIDEO or TV, go to videoDetail.  
                                          item={item} 
                                          color='#000' 
                                        />
                                      </Grid>
                                  </Grid>
                                  <Divider className={classes.customDivider} />
                                </React.Fragment>
                                :
                                <ResultItems item={item} />
                              }
                            </React.Fragment>
                          )
                        })}
                        <Pagination lastPage={meta && meta.last_page ? meta.last_page : null} 
                          page={this.props.page}
                          query={this.props.url.query} />
                      </React.Fragment>
                      :
                      this.searchResultItems()
                      // this.isActive('Date') ? this.searchDateItems() : this.searchRelevanceItems()
                    }
                 </div>
                  : ''
              }  
          </Grid>
        </Grid>
      </div>
      </div>
    );
  }

  updateDataLayer () {
    let avgTotal = this.props.meta.total < 1000 ? (this.props.meta.total > 100 ? ('~'+Math.floor(this.props.meta.total/100)+'00') : (this.props.meta.total > 10 ? ('~'+Math.floor(this.props.meta.total/10)+'0') : '<10')) : ('>'+Math.floor(this.props.meta.total/1000)+'K');
    tagManagerArgs.dataLayer.eventAction = this.props.searchResult.length == 0 ? "zero results" : avgTotal + " results";
    tagManagerArgs.dataLayer.eventLabel = `q=${this.props.url.query.q},p=${this.props.page},lp=${this.props.meta.last_page},t=${this.props.meta.total},sort=${this.props.url.query.sort},tp=${this.props.url.query.sc}`;
  }

  componentDidMount () {
    this.updateDataLayer();
    TagManager.dataLayer(tagManagerArgs)
  }

  componentDidUpdate(previousProps, previousState){
    const previousPropsQuery = previousProps.url.query.q + previousProps.url.query.page + previousProps.url.query.sc + previousProps.url.query.sort;
    const propsQuery = this.props.url.query.q + this.props.url.query.page + this.props.url.query.sc + this.props.url.query.sort;
    if(previousPropsQuery != propsQuery) {
      this.updateDataLayer();
      TagManager.dataLayer(tagManagerArgs);
    }
  }

  static getDerivedStateFromProps(nextProps, prevState){
    if(prevState.type !== nextProps.url.query.sc){
        return ({
          selectedTabName: nextProps.url.query.sort ? nextProps.url.query.sort : 'date',
          type: nextProps.url.query.sc ? nextProps.url.query.sc : 'all',
          loading: false
      })
    }
    return {};
  }
}

SearchResult.propTypes = {
  searchResult: PropTypes.arrayOf(PropTypes.object).isRequired,
  meta: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  searchResult: state.posts.searchResult.data,
  meta: state.posts.searchResult.meta,
});

// SearchResult.propTypes = {
//   searchDate: PropTypes.arrayOf(PropTypes.object).isRequired,
//   searchRelevance: PropTypes.arrayOf(PropTypes.object).isRequired,
//   meta: PropTypes.object.isRequired,
//   searchRelevanceMeta: PropTypes.object.isRequired,
// };

// const mapStateToProps = state => ({
//   searchDate: state.posts.searchDate.data,
//   meta: state.posts.searchDate.meta,
//   searchRelevance: state.posts.searchRelevance.data,
//   searchRelevanceMeta: state.posts.searchRelevance.meta
// });

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchSearchResult
    },
    dispatch
  );

export default withRedux(Store, mapStateToProps, mapDispatchToProps)(
  withReduxSaga(withStyles(styles)(SearchResult))
);
